export default __webpack_public_path__ + "static/media/starken-color.e803c819.svg";